module.exports = __webpack_public_path__ + "img/as.16f433a6.svg";